interface AiGeneratedBadgeProps {
  /**
   * Hover text explaining the provenance. Callers pass a surface-specific
   * message (a read-only page and an edit form imply different next steps).
   */
  title?: string;
  className?: string;
}

/**
 * Pill marking a field whose value came from AI rather than from a person.
 * Shared by the venue detail page, the venue edit form, and the venue
 * management Content Status panel so the marker reads the same everywhere.
 */
export const AiGeneratedBadge = ({
  title = 'This content was generated by AI from public sources and has not been reviewed by the venue.',
  className,
}: AiGeneratedBadgeProps) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 text-[11px] uppercase tracking-wide rounded-full bg-amber-50 text-amber-800 border border-amber-200${
      className ? ` ${className}` : ''
    }`}
    title={title}
  >
    AI Generated
  </span>
);
